export default defineAppConfig({
  // default configuration
  datoCmsPreview: {
    webhookSecretHeader: "X-Webhook-Secret",
    componentShowWhenDraftDisabled: false,
  }
});
